// src/beta/services/stories.ts
import { api } from '@/beta/services/api';
import type { V1StorySummary } from '@/beta/types/dossier';
import type { V1StoryDetail } from '@/beta/types/story';

interface Resp { version: 1; vehicle_id: string; data: { stories: V1StorySummary[] }; generated_at: string; }

export async function getStories(vehicleId: string) {
  const res = await api<Resp>(`/vehicles/${vehicleId}/stories`);
  return res.data;
}

interface StoryDetailResponse {
  version: 1;
  vehicle_id: string;
  data: V1StoryDetail;
  generated_at: string;
}

/** GET /v1/stories/[storyId] — single story with rendered slides.
 *  Slides are pre-shaped by the API's blocksToSlides() — caller renders directly. */
export async function getStory(storyId: string) {
  const res = await api<StoryDetailResponse>(`/v1/stories/${storyId}`);
  return res.data;
}
